import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow, { TableRowProps } from '@mui/material/TableRow';

// ----------------------------------------------------------------------

type Props = TableRowProps & {
  rows?: number;
  withAvatar?: boolean;
  loading: boolean;
  rowHeight?: number;
  children: React.ReactNode;
};

export default function TableLoading({
  rows = 1,
  loading,
  withAvatar,
  rowHeight = 44,
  children,
  ...other
}: Props) {
  if (loading) {
    const array = Array.from({ length: rows }, (_, index) => index);

    return array.map((index) => (
      <TableRow {...other} key={index}>
        <TableCell colSpan={12}>
          <Stack spacing={3} direction="row" alignItems="center" height={rowHeight}>
            <Stack spacing={3} direction="row" alignItems="center">
              {withAvatar && (
                <Skeleton sx={{ borderRadius: 1, width: 40, height: 40, flexShrink: 0 }} />
              )}
              <Skeleton sx={{ width: 60, height: 12 }} />
            </Stack>
            <Skeleton sx={{ width: 1, height: 12 }} />
            <Skeleton sx={{ width: 120, height: 12 }} />
            <Skeleton sx={{ width: 180, height: 12 }} />
            <Skeleton sx={{ width: 160, height: 12 }} />
          </Stack>
        </TableCell>
      </TableRow>
    ));
  }

  return children;
}
